/**
 * Which radio-resolve row answers the identifier an operator typed.
 *
 * The change-unit dialog validates one ICCID or MAC at a time against the
 * radio resolve endpoint, which answers with one row per identifier asked
 * about. Picking the right row is what lets the dialog tell a radio it knows
 * from a valid SIM with no radio row yet from an identifier it has never
 * seen.
 *
 * Contains:
 * - findResolveMatch — the row answering one identifier, or undefined
 */

/**
 * Find the resolve row answering `identifier`.
 *
 * @param {Array<{iccid: string, radio: ?object, valid: ?boolean, creatable: ?boolean}>} rows
 *   Rows as `resolveRadios` returns them — the unwrapped array, never the
 *   `{data}` envelope.
 * @param {string} identifier - The ICCID or MAC entered.
 * @returns {object|undefined} The answering row, or undefined when absent.
 */
export const findResolveMatch = (rows, identifier) =>
  rows?.find(
    entry => entry.iccid === identifier || entry.iccid?.endsWith(identifier) || identifier?.endsWith(entry.iccid),
  );
